var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            {
              staticClass:
                "timeline-main-section col-12 float-l default-bx-shadow"
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "timeline" },
                  [
                    _vm._l(_vm.posts, function(item) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "justify-content-end justify-content-md-around align-items-start  timeline-nodes"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-10 col-md-5 order-3 order-md-1 timeline-content default-bx-shadow",
                                style: _vm.statusStyle(item.status)
                              },
                              [
                                _c("h6", { staticClass: "float-r" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.capitalize(item.status))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("h3", [_vm._v(_vm._s(item.title))]),
                                _vm._v(" "),
                                _c("h5", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.moment(item.start_date_time))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("h6", [
                                  _vm._v(" Company: " + _vm._s(item.company))
                                ]),
                                _vm._v(" "),
                                _c("h7", [
                                  _vm._v(
                                    " Social Media: " +
                                      _vm._s(
                                        _vm.capitalizeFirstLetter(
                                          item.social_media_type
                                        )
                                      )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _vm._l(item.media, function(media_img) {
                                  return [
                                    media_img.file_type == "video/mp4"
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "swiper-slide swiper-slide-active",
                                              staticStyle: {
                                                width: "40.1034px",
                                                "margin-right": "8px",
                                                "background-color":
                                                  "transparent"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "timeline-img",
                                                attrs: {
                                                  src:
                                                    "/static/images/video-icon.png"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    media_img.file_type != "video/mp4"
                                      ? [
                                          _c("img", {
                                            staticClass: "timeline-img",
                                            staticStyle: { height: "50%" },
                                            attrs: {
                                              src: _vm.imageUrl(
                                                media_img.document
                                              )
                                            }
                                          })
                                        ]
                                      : _vm._e()
                                  ]
                                }),
                                _vm._v(" "),
                                _c("p", {
                                  staticStyle: { overflow: "auto" },
                                  domProps: {
                                    innerHTML: _vm._s(item.description)
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    item.has_tags != ""
                                      ? [
                                          _vm._l(
                                            _vm.hashTagSet(item.has_tags),
                                            function(tags, index) {
                                              return [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: _vm.hashTagUrl(
                                                        tags
                                                      ),
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(tags) + " ")]
                                                )
                                              ]
                                            }
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "back_button btn btn-primary pull-right",
                                    attrs: { type: "submit" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.deletePost(item)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            Delete"
                                    )
                                  ]
                                )
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "col-10 col-md-5 order-1 order-md-3 py-3 timeline-date"
                            })
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Timeline")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e5784c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e5784c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/socialmedia/PostTimeline.vue
// module id = null
// module chunks = 